import { Controller } from "@hotwired/stimulus"

// Opens a modal overlay by element id by toggling Tailwind classes
// Usage: <button data-controller="modal-launcher" data-modal-launcher-target-id-value="request-modal" data-action="click->modal-launcher#open">Open</button>
export default class extends Controller {
  static values = { targetId: String, openClass: { type: String, default: "flex" } }
  open() {
    const id = this.targetIdValue
    if (!id) return
    const el = document.getElementById(id)
    if (!el) return
    el.classList.remove("hidden")
    el.classList.add(this.openClassValue)
  }
}
